import {Button, HStack, Input, StackProps, Text, VStack} from "@chakra-ui/react";
import * as React from "react";
import {ChangeEvent, useEffect, useState} from "react";

export interface SelectorElement {
    id: string;
    name: string;
}

export interface OneElementSelectorProps extends StackProps {
    fieldName: string,
    placeholder: string,
    openField: boolean,
    setOpenField: React.Dispatch<React.SetStateAction<boolean>>,
    selectedItem?: SelectorElement,
    setSelectedItem: React.Dispatch<React.SetStateAction<SelectorElement | undefined>>,
    items: SelectorElement[]
}

export const OneElementSelector = ({
                                       fieldName,
                                       placeholder,
                                       openField,
                                       setOpenField,
                                       selectedItem,
                                       setSelectedItem,
                                       items,
                                       ...other
                                   }: OneElementSelectorProps) => {
    const [finalList, setFinalList] = useState<SelectorElement[]>(items);
    const [inputText, setInputText] = useState<string>();

    useEffect(() => {
        if (items.length > 0)
            setFinalList(items);
    }, [items]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const input = event.target.value;
        setInputText(input);
        setFinalList(items.filter(value => value.name.toLowerCase().includes(input.toLowerCase())));
    };

    useEffect(() => {
        if(selectedItem?.id === "-1" || !selectedItem) {
            setInputText('');
        } else {
            setInputText(selectedItem?.name);
        }
    }, [selectedItem?.id]);

    return <VStack alignItems={'stretch'} w={'100%'} {...other}>
        <Text fontWeight={'bold'} color={'primary.400'}>{fieldName}</Text>
        <FloatingDiv mainElement={<Input
            variant='filled'
            colorScheme={"primary"}
            onClick={() => setOpenField(true)}
            type={'text'}
            value={inputText}
            onChange={handleInputChange}
            placeholder={placeholder}
            _placeholder={{
                fontSize: 14
            }}
        />} showDiv={openField} setShowDiv={setOpenField}>
            <VStack w={'100%'} alignItems={'stretch'}>
                <VStack w={'100%'} alignItems={'stretch'} h={'160px'} overflowY={'auto'}>
                    {finalList.map((value, index) => {
                        const {id, name} = value || {};
                        const isSelected = selectedItem?.id === id;
                        return <HStack
                            key={`element_key_${index}`}
                            w={'100%'}
                            minH={'48px'}
                            px={'16px'}
                            cursor={'pointer'}
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                            _hover={{
                                backgroundColor: "rgba(0,0,0,0.03)",
                                color: 'black'
                            }}
                            onClick={() => {
                                if (id === "-1") setInputText('');
                                else setInputText(name);
                                setSelectedItem(value);
                                setOpenField(false);
                            }}
                            borderColor={isSelected ? '#006c4b' : 'rgba(0,0,0,0.5)'}
                            borderWidth={isSelected ? '2px' : '1px'}
                            borderRadius={"4px"}>
                            <Text color={isSelected ? '#006c4b' : 'black'}
                                  fontWeight={isSelected ? 'bold' : 'regular'}>{name}</Text>
                        </HStack>
                    })}
                </VStack>

                <Button variant={'outlined'} fontSize={'14px'} colorScheme={'primary'}
                        onClick={() => {
                            if (selectedItem?.id === "-1") setSelectedItem(undefined);
                            setInputText("");
                            setOpenField(false);
                        }}>Chiudi</Button>
            </VStack>
        </FloatingDiv>
    </VStack>
}

const FloatingDiv = ({children, mainElement, showDiv, setShowDiv}: {
    children: React.ReactNode,
    showDiv: boolean,
    mainElement: React.ReactNode,
    setShowDiv: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    return (
        <div style={{position: 'relative', display: 'inline-block'}}>
            {mainElement}

            {showDiv && (
                <div
                    style={{
                        position: 'absolute',
                        top: '100%',
                        width: '100%',
                        left: '0',
                        marginTop: '8px',
                        padding: '10px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                        zIndex: 1000,
                    }}
                >{children}</div>
            )}
        </div>
    );
};

export default FloatingDiv;
